import ZObject from 'zobject/ZObject.js';

export default superclass => class extends superclass {
    sliderCanvases = {};
    sliderMeshes = {};
    sliderPlanes = {};
    sliderCameras = {};
    sliderRenderers = {};

    onSliderMaterial(msg) {
        // material changed (perhaps even just uniforms)
        this.sliderMaterial = msg;

        for (let n in this.sliderMeshes) {
            let mesh = this.sliderMeshes[n];
            if (mesh) {
                if (mesh.inlets["1"].connections.length === 0) {
                    let material = this.inlets["sliders material"].connections[0].sourceNode;
                    this.sliderMeshes[n].connectInlet("1", material, "Output 1");
                    this.sliderPlanes[n].bang();
                    this.sliderCameras[n].bang();
                } else {
                    //this.sliderMeshes[n].onArg(1, msg);
                    this.sliderRenderers[n].onInputMessage(this.sliderRenderers[n].lastMessageReceived);
                }
            }
        }
    }

    newZObject(text) {
        let zobject = new ZObject(this.subSequence);
        zobject.text = text;
        return zobject;
    }

    newSliderRenderer(slotNumber) {
        let plane = this.newZObject("three.planeGeometry");
        let scene = this.newZObject("three.scene");
        let mesh = this.newZObject("three.mesh");
        let camera = this.newZObject("three.orthographicCamera 0 150 0 150 -1 1");
        let render = this.newZObject("three.render");
        render.connectInlet("1", camera, "Output 1");
        render.connectInlet("Input", scene, "Output 1");
        scene.connectInlet("Input", mesh, "Output 1");
        mesh.connectInlet("Input", plane, "Output 1");
        let canvas = this.newZObject("three.canvas");
        canvas.effect.connectInlet("operation", render, "Output 1");
        camera.bang();

        this.sliderPlanes[slotNumber] = plane;
        this.sliderMeshes[slotNumber] = mesh;
        this.sliderCanvases[slotNumber] = canvas;
        this.sliderCameras[slotNumber] = camera;
        this.sliderRenderers[slotNumber] = render;
        return canvas;
    }

    freeSliderRenderer(slotNumber) {
        this.sliderMeshes[slotNumber] = undefined;
        this.sliderCanvases[slotNumber] = undefined;
    }

}
